import { Link } from 'react-router-dom'
import {
  countdownLabel,
  countdownParts,
  eventDetailPath,
  registrationStatus,
} from '../events/discovery'
import { useEventDiscovery } from '../events/usePublicEvents'
import './NextEventBanner.css'

export default function NextEventBanner() {
  const { ready, bannerEvent: event, now } = useEventDiscovery(1000)
  if (!ready || !event) return null
  const parts = countdownParts(event.start_at, now)
  const countdown = countdownLabel(parts)
  const registration = registrationStatus(event, now)
  return (
    <Link className="next-event-banner" to={eventDetailPath(event)}>
      <span className="next-event-copy">
        <span className="next-event-title">{event.title}</span>
        {registration.label && <span className="next-event-status">{registration.label}</span>}
      </span>
      <span className="next-event-countdown">{countdown}</span>
    </Link>
  )
}
